export const getFcmToken = 'sailapp://get_fcm_token';
export const prefsClear = 'sailapp://prefs_clear';
